import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "Sivas masaj salonu randevusu nasıl alınır?",
    a: "Hizmetinizi seçin, tarih ve saati belirleyin, bilgilerinizi girin ve talebinizi WhatsApp ile gönderin. Kesin onay salonumuz tarafından WhatsApp üzerinden yapılır.",
  },
  {
    q: "Lunessa Spa Masaj nerede?",
    a: "Kızılırmak, 27. Sokak No:2B, 58010 Merkez / Sivas adresindeyiz. Konum için alt bölümdeki Konum butonunu kullanabilirsiniz.",
  },
  {
    q: "Çalışma saatleriniz nedir?",
    a: "Her gün 11:00 – 03:00 arasında hizmet veriyoruz.",
  },
  {
    q: "Hangi masaj ve spa hizmetleri var?",
    a: "Klasik, Bali, Thai, Medikal, Sporcu, Soft, Terapötik, Sultan ve Osmanlı masajı ile Sauna ve Jakuzi hizmetlerimiz bulunur.",
  },
];

export default function FaqSection() {
  return (
    <section className="faq" data-testid="faq-section">
      <h2 className="faq-title">Sık Sorulan Sorular</h2>
      {FAQS.map((f, i) => (
        <details className="faq-item" key={i} data-testid={`faq-item-${i}`}>
          <summary>
            {f.q}
            <ChevronDown size={16} />
          </summary>
          <p>{f.a}</p>
        </details>
      ))}
    </section>
  );
}
